<template>
    <div>
        <DowngradeHeader />

        <div class="downgrade-page__content">
            <div class="gr px-3 md:px-6">
                <DowngradeFeaturesList />

                <DowngradeForm />
            </div>
        </div>
    </div>
</template>

<script>
import DowngradeHeader from "./DowngradeHeader";
import DowngradeFeaturesList from "./DowngradeFeaturesList";
import DowngradeForm from "./DowngradeForm";

export default {
    components: {
        DowngradeHeader,
        DowngradeFeaturesList,
        DowngradeForm
    },

    metaInfo: () => ({
        bodyAttrs: { class: "downgrade-page with--nav-background" },
        link: [{ rel: "stylesheet", href: "/assets/site/css/downgrade.css?v=2" }]
    })
};
</script>